import { OidcSecure } from "@axa-fr/react-oidc";
import { useTranslation } from "react-i18next";
import {
    BrowserRouter,
    Navigate,
    Outlet,
    Route,
    Routes,
} from "react-router-dom";

import { Layout } from "./components/Layout";
import { PageRoot } from "./components/Layout/PageRoot";
import { Page, PagesFinder } from "./pages";
import { NotFoundPage } from "./pages/Errors/NotFound";

interface ReducedPages {
    layout: Page[];
    noLayout: Page[];
}

export function Router() {
    const { t } = useTranslation();

    const pages = PagesFinder.getPages(undefined, true);

    const routes = pages.reduce<ReducedPages>(
        (prev, curr) => {
            if (curr.noLayout) {
                prev.noLayout.push(curr);
            } else {
                prev.layout.push(curr);
            }
            return prev;
        },
        { layout: [], noLayout: [] },
    );

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    index
                    element={<Navigate to="/app/dashboard" replace />}
                />

                <Route
                    path="app"
                    element={
                        <OidcSecure>
                            <Layout>
                                <Outlet />
                            </Layout>
                        </OidcSecure>
                    }
                >
                    {routes.layout.map(page => {
                        const RouteElement = page.element;
                        return (
                            <Route key={`page_${page.path}`} path={page.path}>
                                <Route
                                    index
                                    element={
                                        <PageRoot title={t(page.name)}>
                                            <RouteElement />
                                        </PageRoot>
                                    }
                                />
                                {page.children?.map(childPage => {
                                    const ChildRouteElement = childPage.element;
                                    return (
                                        <Route
                                            key={`page_${page.path}`}
                                            path={childPage.path}
                                            element={
                                                <PageRoot
                                                    title={t(
                                                        childPage.title ??
                                                            page.name,
                                                    )}
                                                >
                                                    <ChildRouteElement />
                                                </PageRoot>
                                            }
                                        />
                                    );
                                })}
                            </Route>
                        );
                    })}
                    <Route path="404" element={<NotFoundPage />} />
                </Route>

                <Route
                    path="app"
                    element={
                        <OidcSecure>
                            <Outlet />
                        </OidcSecure>
                    }
                >
                    {routes.noLayout.map(page => {
                        const RouteElement = page.element;
                        return (
                            <Route key={`page_${page.path}`} path={page.path}>
                                <Route index element={<RouteElement />} />
                                {page.children?.map(childPage => {
                                    const ChildRouteElement = childPage.element;
                                    return (
                                        <Route
                                            key={`page_${page.path}`}
                                            path={childPage.path}
                                            element={
                                                <PageRoot
                                                    title={t(
                                                        childPage.title ??
                                                            page.name,
                                                    )}
                                                >
                                                    <ChildRouteElement />
                                                </PageRoot>
                                            }
                                        />
                                    );
                                })}
                            </Route>
                        );
                    })}
                    <Route path="404" element={<NotFoundPage />} />
                </Route>

                <Route path="*" element={<Navigate to="/app/404" replace />} />
            </Routes>
        </BrowserRouter>
    );
}
